// extracted by mini-css-extract-plugin
module.exports = {"container":"Name_container__CPmYe","text":"Name_text__3fXt0","job":"Name_job__JQNFr"};